import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgba(30, 107, 170, 1)',
      dark: 'rgba(18, 66, 105, 1)',
      light: '#4F91A5',
      contrastText: '#fff',
      hover: 'rgba(36, 122, 148, 0.08)',
      selected: 'rgba(35, 117, 143, 0.12)',
      focus: 'rgba(35, 117, 143, 0.18)',
      focusVisible: 'rgba(35, 117, 143, 0.3)',
      outlineBorder: 'rgba(35, 117, 143, 0.5)',
    },
    secondary: {
      main: '#0C2631',
      dark: '#091B23',
      light: '#5C6E75',
      contrastText: '#fff',
    },
    error: {
      main: '#D32F2F',
      dark: '#C62828',
      light: '#EF5350',
      contrastText: '#fff',
      hover: 'rgba(211, 47, 47, 0.08)',
    },
    success: {
      main: '#2E7D32',
      dark: '#1B5E20',
      light: '#4CAF50',
      contrastText: '#fff',
      backgroundColor: '#EDF7ED',
    },
    warning: {
      main: '#EF6C00',
      dark: '#C25700',
      light: '#FFF4E5',
      contrastText: '#663C00',
    },
    info: {
      main: '#0288D1',
      dark: '#01579B',
      light: '#03A9F4',
      contrastText: '#fff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hover: 'rgba(0, 0, 0, 0.08)',
    },
    background: {
      default: '#fff',
      paper: '#fafafa',
      dark: 'rgba(30, 107, 170, 1)',
    },
    action: {
      active: 'rgba(0, 0, 0, 0.56)',
      hover: 'rgba(0, 0, 0, 0.08)',
      selected: 'rgba(0, 0, 0, 0.12)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      disabledBackground: 'rgba(0, 0, 0, 0.12)',
      focus: 'rgba(0, 0, 0, 0.18)',
    },
    // divider: {
    //   main: 'rgba(0, 0, 0, 0.12)',
    // },
    divider: 'rgba(0, 0, 0, 0.12)',
    common: {
      black: 'rgba(0, 0, 0, 0.87)',
      white: '#fff',
      neutral: {
        light: '#768085',
        main: '#334249',
        dark: 'rgba(255, 255, 255, 0.7)',
      },
    },
    customWhite: {
      main: '#fff',
    },
  },
  typography: {
    // fontFamily: ["Open Sans", "sans-serif"].join(","),
    fontFamily: 'Open Sans, sans-serif',
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    color: 'rgba(0, 0, 0, 0.87)',
    h1: {
      fontSize: 30,
      fontWeight: 600,
      wordBreak: 'break-word',
      textTransform: 'capitalize',
      lineHeight: 'normal',
      '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        fontSize: 30,
      },
      '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
        fontSize: 30,
        whiteSpace: 'normal',
      },
    },
    h2: {
      fontSize: 24,
      fontWeight: 700,
      wordBreak: 'break-word',
      '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        fontSize: 24,
      },
      '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
        fontSize: 24,
      },
    },
    h3: {
      fontSize: 22,
      fontWeight: 600,
      wordBreak: 'break-word',
      '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        fontSize: 22,
      },
      '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
        fontSize: 22,
      },
    },
    h4: {
      fontSize: 16,
      fontWeight: 600,
      wordBreak: 'break-word',
      '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        fontSize: 16,
      },
      '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
        fontSize: 16,
      },
    },
    h5: {
      fontSize: 14,
      fontWeight: 600,
      wordBreak: 'break-word',
      '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        fontSize: 14,
      },
      '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
        fontSize: 14,
      },
    },
    h6: {
      fontSize: 12,
      fontWeight: 600,
      wordBreak: 'break-word',
      '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        fontSize: 12,
      },
      '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
        fontSize: 12,
      },
    },
    body1: {
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
      fontWeightBold: 700,
      color: 'rgba(0, 0, 0, 0.87)',
      '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        fontSize: 14,
      },
      '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
        fontSize: 14,
      },
    },
    body2: {
      fontSize: 13,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
      fontWeightBold: 700,
      color: 'rgba(0, 0, 0, 0.60)',
      '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        fontSize: 13,
      },
      '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
        fontSize: 13,
      },
    },
    caption: {
      fontSize: 12,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
      fontWeightBold: 700,
      color: 'rgba(0, 0, 0, 0.60)',
    },
    subtitle1: {
      fontSize: 16,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
      fontWeightBold: 700,
    },
    subtitle2: {
      fontSize: 13,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
      fontWeightBold: 700,
    },
    button: {
      fontSize: 16,
    },
    overline: {
      fontSize: 12,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
      fontWeightBold: 700,
      color: 'rgba(0, 0, 0, 0.60)',
      letterSpacing: '1px',
    },
  },

  components: {
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontSize: '18px',
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: '16px',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          maxWidth: '600px',
          '@media screen and (min-device-width: 768px)': {
            minWidth: '440px',
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
          backgroundColor: '#fff',
          color: 'rgba(0, 0, 0, 0.87)',
          fontSize: '14px',
          '& .MuiDataGrid-withBorderColor': {
            borderColor: '#e0e0e0',
          },
          '& .MuiDataGrid-row': {
            backgroundColor: '#fff',
          },
          '& .MuiDataGrid-row:hover, & .MuiDataGrid-root .MuiDataGrid-row.Mui-hovered': {
            backgroundColor: 'rgba(36, 122, 148, 0.08)',
          },
          '& .MuiDataGrid-row.Mui-selected': {
            backgroundColor: 'rgba(35, 117, 143, 0.08)',
          },
          '& .MuiTablePagination-selectLabel': {
            fontWeight: 600,
          },
          '& .MuiTablePagination-displayedRows': {
            color: 'rgba(0, 0, 0, 0.87)',
            fontWeight: 600,
          },
          '& .MuiTablePagination-actions .MuiButtonBase-root.MuiIconButton-root': {
            color: 'rgba(30, 107, 170, 1)',
          },
          '& .MuiTablePagination-actions .MuiButtonBase-root.MuiIconButton-root.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.38)',
          },
          '& .MuiSelect-select.MuiInputBase-input': {
            minWidth: '35px !important',
            padding: '0px 10px 0px 0px !important',
            color: 'rgba(0, 0, 0, 0.87)',
            textAlignLast: 'left !important',
            fontSize: '14px',
          },
          '& .MuiInputBase-root.MuiTablePagination-input': {
            marginRight: '22px !important',
          },
          '& .MuiTablePagination-actions': {
            marginLeft: '15px !important',
          },
          '& .MuiDataGrid-columnHeaders:hover .MuiDataGrid-columnSeparator': {
            visibility: 'hidden',
            width: 'auto',
          },
        },
        virtualScroller: {
          /* overflowX: 'hidden !important', */
        },
        footerContainer: {
          background: '#fff',
          /* borderRadius: '0 0 4px 4px', */
          /* boxShadow:
            '0px 3px 5px -1px rgba(0, 0, 0, 0.20), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)', */
        },
        iconButtonContainer: {
          width: 'auto',
        },
        columnHeaders: {
          backgroundColor: '#fff',
        },
        columnHeader: {
          '&:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
            opacity: 1,
          },
          '&:focus': {
            outline: 'none',
          },
          '&:focus-within': {
            outline: 'none',
          },
        },
        cell: {
          '&:focus': {
            outline: 'none',
          },
          '&:focus-within': {
            outline: 'none',
          },
        },
        panelWrapper: {
          borderRadius: '4px',
          boxShadow:
            '0px 5px 5px -3px rgba(0, 0, 0, 0.20), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
        },
      },
    },
    MuiPickersPopper: {
      styleOverrides: {
        paper: {
          // Styles for MuiPickersPopper-paper
          boxShadow:
            '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          position: 'absolute',
          zIndex: 1,
          background: '#fff',
          boxShadow:
            '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          '&:hover ': {
            // border: '1px solid rgba(36, 122, 148, 0.08)!important',
            borderColor: 'transparent!important',
            background: 'rgba(36, 122, 148, 0.08)',
          },
          '&:not(.Mui-selected)': {
            borderColor: 'rgba(30, 107, 170, 1)',
            borderWidth: '2px',
            // background: 'transparent',
          },
          '&.MuiDateRangePickerDay-day:not(.Mui-selected)': {
            borderColor: 'rgba(30, 107, 170, 1)',
            borderWidth: '2px',
          },
        },
      },
    },
    MuiDateRangePickerDay: {
      styleOverrides: {
        root: {
          '&:first-of-type .MuiDateRangePickerDay-rangeIntervalDayPreview': {
            borderLeftColor: 'transparent',
          },
          '&:last-of-type .MuiDateRangePickerDay-rangeIntervalDayPreview': {
            borderRightColor: 'transparent',
          },
          '&.MuiDateRangePickerDay-outsideCurrentMonth.MuiDateRangePickerDay-hiddenDayFiller .MuiDateRangePickerDay-rangeIntervalDayPreview':
            {
              backgroundColor: 'transparent',
            },
          '&.MuiDateRangePickerDay-rangeIntervalDayHighlight button': {
            color: '#fff',
          },
          '&.MuiDateRangePickerDay-rangeIntervalDayHighlight.MuiDateRangePickerDay-outsideCurrentMonth.MuiDateRangePickerDay-hiddenDayFiller':
            {
              backgroundColor: 'transparent',
            },
        },
        rangeIntervalDayHighlight: {
          backgroundColor: 'rgba(30, 107, 170, 1)',
        },
        rangeIntervalDayPreview: {
          borderColor: 'transparent',
          borderLeftColor: 'transparent',
          borderRightColor: 'transparent',
          background: 'rgba(36, 122, 148, 0.08)',
        },
      },
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: {
          color: 'rgba(0, 0, 0, 0.38)',
          fontWeight: '600',
        },
      },
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        root: {
          '& .MuiTypography-root': {
            fontWeight: 600,
          },
        },
      },
    },
    MuiMultiInputDateRangeField: {
      styleOverrides: {
        separator: {
          display: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          height: '26px',
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: '400',
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'success' && {
              backgroundColor: '#EDF7ED',
              border: '1px solid rgba(46, 125, 50, 0.5)',
            }),
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'warning' && {
              backgroundColor: '#FFF4E5',
              border: '1px solid rgba(239, 108, 0, 0.5)',
            }),
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'info' && {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              border: '1px solid #BDBDBD',
            }),
          ...(ownerState.variant === 'outlined' &&
            ownerState.color === 'info' && {
              backgroundColor: '#fff',
              border: '1px solid #BDBDBD',
            }),
        }),
        label: {
          color: 'rgba(0, 0, 0)',
        },
        deleteIcon: {
          color: 'rgba(0, 0, 0, 1)',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '10px',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        scroller: {
          '& .Mui-selected': {
            background: 'transparent',
            borderRadius: '0px 0px 0 0',
          },
          '& .MuiTab-root': {
            marginTop: '2px',
            marginLeft: '2px',
            marginRight: '2px',
            marginBottom: '2px',
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px 24px !important',
          '& > :not(style) ~ :not(style)': {
            marginLeft: '16px',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {},
        input: {
          fontSize: 16,
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: 400,
          padding: '12px 12px 12px 12px!important',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: 16,
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: 400,
          // border: '1px solid rgba(0, 0, 0, 0.23)',
          borderRadius: 4,
          '&.Mui-disabled': {
            opacity: '0.6',
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            // borderColor: 'transparent',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23) !important',
            borderWidth: '2px !important',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
          },
          '&.Mui-focused': {
            borderColor: 'rgba(30, 107, 170, 1)',
            boxShadow: 'none',
          },
          '&:hover': {
            borderColor: '#000!important',
            boxShadow: 'none',
          },
          '&.Mui-error': {
            borderColor: '#D32F2F',
          },
        },
        input: {
          '&::placeholder': {
            color: 'rgba(0, 0, 0, 0.60)',
            opacity: '1',
          },
        },
        inputMultiline: {
          borderRadius: 4,
          padding: 10,
        },
        multiline: {
          padding: 0,
        },
        notchedOutline: {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.87)!important',
          fontSize: '14px!important',
          fontWeight: '600!important',
          marginBottom: '0px!important',
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiFormLabel-root': {
            transform: 'translate(14px, 14px) scale(1)',
            paddingLeft: '0px',
            paddingRight: '0px',
            background: '#fff',
            fontSize: '16px!important',
            color: 'rgba(0, 0, 0, 0.60)!important',
            fontWeight: '400!important',
          },
          '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
          '& .Mui-focused': {
            color: 'rgba(0, 0, 0, 0.6) !important',
          },
          /* '& .Mui-error': {
            color: '#D32F2F!important',
          }, */
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: { padding: 0 },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {},
        paper: {
          background: '#fff',
          border: '1px solid #0000001F',
          // boxShadow: '0px 2px 1px 0px #00000033',
          boxShadow:
            '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeSmall: {
          fontSize: '20px',
        },
        fontSizeMedium: {
          fontSize: '26px',
        },
        fontSizeLarge: {
          fontSize: '32px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: '0px',
          },
          '& .MuiFormLabel-root': {
            transform: 'translate(14px, 12px) scale(1)',
          },
          '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
        },

        groupLabel: {
          backgroundColor: '#fff',
          textTransform: 'uppercase',
          fontSize: '12px',
          lineHeight: '32px',
        },
        groupUl: {
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          paddingBottom: '10px',
          marginBottom: '10px',
          '& .MuiAutocomplete-option': { paddingLeft: '16px!important' },
        },
        // inputRoot: {
        //   height: "45px",
        // },
        listbox: {
          fontSize: '14px',
          background: '#fff',
          border: '1px solid rgba(0, 0, 0, 0.12)',
          borderRadius: '4px',
        },
        input: {
          padding: '12px 12px 12px 12px!important',
        },
        option: {
          '&:hover': {
            backgroundColor: 'rgba(36, 122, 148, 0.08)!important',
          },
          '&$checked': {
            backgroundColor: 'rgba(36, 122, 148, 0.08)!important',
          },
          '&[data-focus="true"]': {
            backgroundColor: 'rgba(36, 122, 148, 0.08)!important',
          },
          '&[aria-selected="true"]': {
            backgroundColor: 'rgba(36, 122, 148, 0.08)!important',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          fontSize: 16,
          color: 'rgba(0, 0, 0, 0.60)',
          marginBottom: '8px',
          fontWeight: '400',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
            background: '#fff',
          },
          '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
            fontSize: 14,
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginTop: '10px',
          marginBottom: '10px',
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          height: 'auto',
          background: 'none',
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          '& .MuiTextField-root': {
            minWidth: 'auto !important',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans, sans-serif',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '400',
          '&:hover': {
            color: 'rgba(30, 107, 170, 1)',
          },
        },
      },
    },
    /* MuiButtonBase: {
      defaultProps: {
        disableRipple: 'true',
      },
    }, */
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '8px',
          border: '2px solid transparent',
          '&.Mui-focusVisible': {
            border: '2px solid rgba(30, 107, 170, 1)',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '8px',
          border: '2px solid transparent',
          '&.Mui-focusVisible': {
            border: '2px solid rgba(30, 107, 170, 1)',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          fontSize: 16,
          fontWeight: 400,
          fontFamily: 'Open Sans, sans-serif',
          // marginLeft: '2px',
          // marginRight: '2px',
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
            // marginLeft: '2px',
            // marginRight: '2px',
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        color: 'primary',
      },
      text: {
        textTransform: 'uppercase',
        fontWeight: '600',
        fontSize: '0.875rem',
        color: '#000',
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          whiteSpace: 'nowrap',
          textTransform: 'uppercase',
          fontSize: 15,
          fontWeight: '600',
          borderRadius: '4',
          minHeight: '40px',
          padding: '5px 12px',
          color: '#fff',
          letterSpacing: '0.5px',
          '@media screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
            fontSize: 15,
          },
          '@media screen and (min-device-width: 320px) and (max-device-width: 767px)': {
            fontSize: 15,
          },
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'primary' && {
              backgroundColor: 'rgba(30, 107, 170, 1)',
              boxShadow:
                '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
              color: '#fff',
              border: '1px solid rgba(30, 107, 170, 1)',
              textTransform: 'uppercase',
              '&:hover': {
                backgroundColor: '#216F87',
                boxShadow:
                  '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
                border: '1px solid #216F87',
                color: '#fff',
              },
            }),
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'secondary' && {
              backgroundColor: '#0C2631',
              boxShadow:
                '0px 3px 1px -2px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
              color: '#fff',
              border: '1px solid #0C2631',
              textTransform: 'uppercase',
              '&:hover': {
                backgroundColor: '#0C2631',
                boxShadow:
                  '0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
                border: '1px solid #0C2631',
                color: '#fff',
              },
            }),
          ...(ownerState.variant === 'outlined' &&
            ownerState.color === 'primary' && {
              backgroundColor: '#fff',
              boxShadow: 'none',
              color: 'rgba(30, 107, 170, 1)',
              border: '1px solid rgba(30, 107, 170, 1)',
              textTransform: 'uppercase',
              fontSize: '13px',
              '&:hover': {
                backgroundColor: 'rgba(36, 122, 148, 0.08)',
                boxShadow: 'none',
                border: '1px solid rgba(30, 107, 170, 1)',
                color: 'rgba(30, 107, 170, 1)',
              },
              '&.Mui-disabled': {
                backgroundColor: '#fff',
                color: 'rgba(0, 0, 0, 0.38)',
                border: '1px solid rgba(0, 0, 0, 0.12)',
              },
            }),
          ...(ownerState.variant === 'outlined' &&
            ownerState.color === 'secondary' && {
              backgroundColor: '#fff',
              boxShadow: 'none',
              color: '#0C2631',
              border: '1px solid rgba(12, 38, 49, 0.50)',
              textTransform: 'uppercase',
              '&:hover': {
                backgroundColor: 'rgba(36, 122, 148, 0.08)',
                boxShadow: 'none',
                border: '1px solid rgba(12, 38, 49, 0.50)',
                color: '#0C2631',
              },
              '&.Mui-disabled': {
                backgroundColor: '#fff',
                color: 'rgba(0, 0, 0, 0.38)',
                border: '1px solid rgba(0, 0, 0, 0.12)',
              },
            }),
          ...(ownerState.variant === 'outlined' &&
            ownerState.color === 'error' && {
              backgroundColor: '#fff',
              boxShadow: 'none',
              color: '#C62828',
              border: '1px solid rgba(211, 47, 47, 0.50)',
              textTransform: 'uppercase',
              fontSize: '13px',
            }),
          ...(ownerState.variant === 'text' &&
            ownerState.color === 'primary' && {
              backgroundColor: '#fff',
              boxShadow: 'none',
              color: 'rgba(30, 107, 170, 1)',
              border: 'none',
              // padding: '0px !important',
              textTransform: 'uppercase',
              fontWeight: '600',
            }),
          ...(ownerState.variant === 'text' &&
            ownerState.color === 'secondary' && {
              backgroundColor: '#fff',
              boxShadow: 'none',
              color: 'rgba(0, 0, 0, 0.6)',
              border: 'none',
              // padding: '0px !important',
              textTransform: 'uppercase',
              fontWeight: '600',
              fontSize: '15px',
            }),
          ...(ownerState.variant === 'text' &&
            ownerState.color === 'error' && {
              backgroundColor: '#fff',
              boxShadow: 'none',
              color: '#D32F2F',
              border: 'none',
              // padding: '0px !important',
              textTransform: 'uppercase',
              fontWeight: '600',
              fontSize: '13px',
            }),
          ...(ownerState.variant === 'text' &&
            ownerState.size === 'small' && {
              backgroundColor: '#fff',
              boxShadow: 'none',
              border: 'none',
              textTransform: 'uppercase',
              fontWeight: '600',
              fontSize: '13px',
            }),
          '&:hover': {
            // backgroundColor: '#0C2631',
            // boxShadow: 'none',
            // border: '1px solid #0C2631',
            // color: '#ffffff',
          },
          '&.Mui-disabled': {
            // backgroundColor: 'rgba(0, 0, 0, 0.12)',
            // color: 'rgba(0, 0, 0, 0.38)',
            // border: '1px solid #F6F7F8',
          },
          '&.MuiButton-containedPrimary': {
            '&.Mui-disabled': {
              backgroundColor: 'rgba(0, 0, 0, 0.12)',
              color: 'rgba(0, 0, 0, 0.38)',
              borderColor: 'transparent',
            },
          },
          '&.MuiButton-containedSecondary': {
            '&.Mui-disabled': {
              backgroundColor: 'rgba(0, 0, 0, 0.12)',
              color: 'rgba(0, 0, 0, 0.38)',
              borderColor: 'transparent',
            },
          },
          '&.MuiButton-outlinedSecondary': {
            '&:hover': {
              backgroundColor: 'rgba(36, 122, 148, 0.08)',
              boxShadow: 'none',
              borderColor: 'rgba(12, 38, 49, 0.50)',
              color: '#0C2631',
            },
          },
          '&.MuiButton-outlinedError': {
            '&:hover': {
              borderColor: 'rgba(211, 47, 47, 0.50)',
            },
          },

          '&.MuiButton-textPrimary': {
            '&:hover': {
              backgroundColor: 'rgba(36, 122, 148, 0.08) !important',
              boxShadow: 'none !important',
              border: 'none !important',
              color: 'rgba(30, 107, 170, 1) !important',
            },
          },
          '&.MuiButton-textError': {
            '&:hover': {
              backgroundColor: 'rgba(211, 47, 47, 0.04) !important',
              boxShadow: 'none !important',
              border: 'none !important',
              color: '#D32F2F !important',
            },
          },
          '&.MuiButton-textSecondary': {
            '&:hover': {
              backgroundColor: 'rgba(36, 122, 148, 0.08) !important',
              boxShadow: 'none !important',
              border: 'none !important',
              color: 'rgba(30, 107, 170, 1) !important',
            },
          },
        }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          boxShadow: 'none',
        },
      },
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1025,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
